import { GraduationCap, Globe, Car, Briefcase } from "lucide-react";

const TYPES = [
  { key: "mandate", label: "Umowa zlecenie", desc: "stawka godzinowa · rachunki co miesiąc", et: "uz" },
  { key: "mandate_per_package", label: "Umowa zlecenie od paczki", desc: "stawka od paczki · rachunki co miesiąc", et: "uz" },
  { key: "employment", label: "Umowa o pracę", desc: "badania, BHP, PIT-2 obowiązkowe", et: "uop" },
];

const Flag = ({ icon: Icon, label, desc, value, onChange, testId }) => (
  <button type="button" role="switch" aria-checked={value} onClick={() => onChange(!value)} data-testid={testId}
    className={`flex items-center gap-3 px-3 py-3 border text-left transition-colors ${value ? "border-zinc-900 bg-zinc-900 text-white" : "border-zinc-300 bg-white hover:border-zinc-900"}`}>
    <Icon className="w-5 h-5 shrink-0" />
    <div><div className="text-xs font-black uppercase tracking-wider">{label}</div><div className={`text-[10px] ${value ? "text-zinc-300" : "text-zinc-500"}`}>{desc}</div></div>
  </button>
);

export const StepProfile = ({ value, onChange }) => (
  <div className="space-y-5" data-testid="onb-step-profile">
    <div>
      <div className="font-label mb-2">// Forma zatrudnienia</div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {TYPES.map((t) => (
          <button key={t.key} type="button" onClick={() => onChange({ ...value, contract_type: t.key, employment_type: t.et })} data-testid={`onb-type-${t.key}`}
            className={`flex items-start gap-3 px-3 py-3 border text-left transition-colors ${value.contract_type === t.key ? "border-brand bg-red-50" : "border-zinc-300 bg-white hover:border-zinc-900"}`}>
            <Briefcase className={`w-5 h-5 shrink-0 ${value.contract_type === t.key ? "text-brand" : "text-zinc-400"}`} />
            <div><div className="text-xs font-black uppercase tracking-wider">{t.label}</div><div className="text-[10px] text-zinc-500">{t.desc}</div></div>
          </button>
        ))}
      </div>
    </div>
    <div>
      <div className="font-label mb-2">// Cechy, które zmieniają listę dokumentów</div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        <Flag icon={GraduationCap} label="Student" desc="do 26 lat · bez składek ZUS · zaświadczenie" value={value.is_student} onChange={(v) => onChange({ ...value, is_student: v })} testId="onb-flag-student" />
        <Flag icon={Globe} label="Cudzoziemiec" desc="karta pobytu · zezwolenie na pracę" value={value.is_foreigner} onChange={(v) => onChange({ ...value, is_foreigner: v })} testId="onb-flag-foreigner" />
        <Flag icon={Car} label="Kierowca" desc="prawo jazdy · badania · BHP" value={value.is_driver} onChange={(v) => onChange({ ...value, is_driver: v })} testId="onb-flag-driver" />
      </div>
    </div>
    {value.employment_type === "uz" && (
      <label className="block max-w-xs"><span className="font-label text-[10px] block mb-1">Rachunki miesięczne</span>
        <select value={value.rachunek_mode} onChange={(e) => onChange({ ...value, rachunek_mode: e.target.value })} data-testid="onb-rachunek-mode" className="w-full h-10 px-2 border border-zinc-300 text-sm bg-white outline-none focus:border-zinc-900">
          <option value="generate">Generuję w aplikacji (PDF)</option>
          <option value="manual">Odhaczam ręcznie (skan)</option>
        </select></label>
    )}
  </div>
);
